import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.libraryprocessmaps, {
    url: '/processmaps',
    params: { title: 'Library -  Process Maps' },
    views: {
      childcontent: {
        controller: [
          'flowModelApiService',
          'APP_CONFIG',
          function (
            flowModelApiService: SharedAngular.FlowModelApiService,
            APP_CONFIG: SharedAngular.APP_CONFIG
          ) {
            if (!flowModelApiService.flowModelsLoaded) {
              flowModelApiService.getFlowModels();
              if (APP_CONFIG.enableTagging) {
                flowModelApiService.getUsedTagsInFlowModels();
              }
            }
          }
        ],
        template:
          '<runner-library-tabs></runner-library-tabs>' +
          '<library-process-maps-grid></library-process-maps-grid>'
      }
    }
  });
}
